import React, { useEffect, useState } from 'react';
import CalendarHeader from './CalendarHeader';
import Timeliner from './Timeliner';
import baseURL from '../../../configs/api';
import moment from 'moment';
import { formatInDateOnly, formatTimeWithCustomAMPM, Views } from './utlis';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../components/hooks/useTheme';
import { EditBlockedPeriod } from '../../fleet/vehicles/blockedPeriods/EditBlockedPeriod';
import Cookies from 'js-cookie';
import useTenant from '../../../components/hooks/useTenant';


const Calendar = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { handleTenantError }: any = useTenant();
  const navigate = useNavigate();
  const [currentTimeLineView, setCurrentTimeLineView] = useState<Views>(Views.TimeSlot3MONTH);
  const [timeLineHeight, setTimeLineHeight] = useState<number>(367);
  const [onPrint, setOnPrint] = useState<(() => void)>(() => { });
  const [resourcesDataIsLoaded, setResourcesDataIsLoaded] = useState<boolean>(false);

  const [vehilceClassData, setVehilceClassData] = useState<any[]>([]);
  const [vehicleClassDataIsDataLoaded, setVehicleClassDataIsDataLoaded] = useState<boolean>(false);

  const [vehilceData, setVehilceData] = useState<any[]>([]);
  const [vehicleDataIsDataLoaded, setVehicleDataIsDataLoaded] = useState<boolean>(false);

  const [reservationItem, setReservationItem] = useState<any[]>([]);
  const [reservationItemsIsLoaded, setReservationItemIsLoaded] = useState<boolean>(false);

  const [customStartDate, setCustomStartDate] = useState<string>("");
  const [customEndDate, setCustomEndDate] = useState<string>("");

  const [vehicleId, setVehicleId] = useState<number>(0);
  const [blockedPeriodId, setBlockedPeriodId] = useState<number>(0);
  const [openEditBlockedPeriod, setOpenEditBlockedPeriod] = useState<boolean>(false);
  const [isRefresh, setIsRefresh] = useState<boolean>(true)

  const statusColor: any[] = [
    { status: "open", color: "#f0ad4e" },            // orange
    { status: "rental", color: "#66BB6A" },          // green
    { status: "overdue", color: "#9933ff" },         // purple
    { status: "completed", color: "#253455" },       // dark blue

    { status: "reopen", color: "#FACC15" },          // bright yellow
    { status: "cancelled", color: "#D92D20" },       // red
    { status: "cancelled paid", color: "#C2185B" },  // pink/red
    { status: "no show", color: "#7D1C4A" },         // dark maroon
    { status: "pending", color: "#808080" },         // gray

    { status: "repair", color: "#0EA5E9" },          // sky blue
    { status: "blocked", color: "#4B5563" }          // slate gray
  ];

  useEffect(() => {
    fetch(`${baseURL}vehicleClass`, {
      method: 'GET',
      headers: {
        'X-Tenant-ID': tenantId?.toString(),
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then((data) => {
        setVehilceClassData(() =>
          data.map((item: any) => {
            return {
              id: item.id,
              title: item.name,
            };
          })
        );

        setVehicleClassDataIsDataLoaded(true);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  useEffect(() => {
    fetch(`${baseURL}vehicles/GetAvailableVehiclesForCalendar`, {
      method: 'GET',
      headers: {
        'X-Tenant-ID': tenantId?.toString(),
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then((data) => {
        setVehilceData(
          data.map((item: any) => {
            return {
              id: item.id,
              title: item.name,
              groupId: item.vehicleClassId
            };
          })
        );

        setVehicleDataIsDataLoaded(true);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  const fetchReservationCalendar = () => {
    setReservationItemIsLoaded(false);

    let startDate = moment();
    let endDate = moment();

    switch (currentTimeLineView) {
      case Views.TimeSlotToday:
        startDate = startDate.clone().startOf('day');
        endDate = endDate.clone().endOf('day');
        break;
      case Views.TimeSlotWEEK:
        startDate = startDate.clone().startOf('week');
        endDate = endDate.clone().endOf('week');
        break;
      case Views.TimeSlotMONTH:
        startDate = startDate.clone().startOf('month');
        endDate = endDate.clone().endOf('month');
        break;
      case Views.TimeSlot3MONTH:
        startDate = startDate.clone().startOf('month');
        endDate = endDate.clone().add(2, 'month').endOf('month');
        break;
      case Views.TimeSlot6MONTH:
        startDate = startDate.clone().startOf('month');
        endDate = endDate.clone().add(5, 'month').endOf('month');
        break;
      case Views.TimeSlotYear:
        startDate = startDate.clone().startOf('year');
        endDate = endDate.clone().endOf('year');
        break;
      case Views.TimeSlotCustom:
        startDate = moment(customStartDate);
        endDate = moment(customEndDate);
        break;
      default:
        startDate = startDate.clone().startOf('month');
        endDate = endDate.clone().add(2, 'month').endOf('month');
        break;
    }

    fetch(`${baseURL}reservation/GetReservationsForCalendarWithDateRange/${formatInDateOnly(startDate)},${formatInDateOnly(endDate)}`, {
      method: 'GET',
      headers: {
        'X-Tenant-ID': tenantId?.toString(),
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then((data) => {
        setReservationItem(
          data.map((item: any) => {
            const customerName = item?.customerName || "";
            let title = `${formatTimeWithCustomAMPM(moment(new Date(item.startDate)))} - ${formatTimeWithCustomAMPM(moment(new Date(item.endDate)))}`;
            if (item?.entryType === "Reservation" || item?.entryType === "Replaced") {
              title = `${formatTimeWithCustomAMPM(moment(new Date(item.startDate)))} - ${formatTimeWithCustomAMPM(moment(new Date(item.endDate)))} ${item.bookingNumber} - ${customerName}`;
            }

            let bgColor = statusColor.find((s: any) => s.status === item.status?.toLowerCase())?.color;
            let borderColor = statusColor.find((s: any) => s.status === item.status?.toLowerCase())?.color;
            if (item?.status === "Blocked") {
              bgColor = item?.backgroundColor || "#000000";
              borderColor = item?.backgroundColor || "#000000";
            }

            if (item?.entryType === "Replaced") {
              bgColor = "#000000";
              borderColor = "#000000";
            }

            return {
              id: item.id,
              entryType: item.entryType,
              showOnGroup: item?.vehicleId <= 0,
              resourceId: item?.vehicleId <= 0 ? item?.vehicleClassId : item?.vehicleId,
              title: title,
              start: item.startDate,
              end: item.endDate,
              bgColor,
              borderColor
            };
          })
        );

        setReservationItemIsLoaded(true);
        setIsRefresh(false);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
        setReservationItem([]);
        setReservationItemIsLoaded(true);
        setIsRefresh(false)
      });
  }

  useEffect(() => {
    fetchReservationCalendar();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTimeLineView, customStartDate, customEndDate]);

  useEffect(() => {
    setReservationItemIsLoaded(false);
    if (!isRefresh) return;
    fetchReservationCalendar();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRefresh]);

  const handleEventClick = (id: number, vehicleId: number, entryType: string) => {
    switch (entryType) {
      case "Reservation":
      case "Replaced":
        navigate(`/carrental/reservations/editreservation?id=${id}`);
        break;
      case "RepairOrder":
        navigate(`/fleet/repairorders/editrepairorder`, { state: id });
        break;
      case "BlockPeriod":
        setVehicleId(vehicleId);
        setBlockedPeriodId(id);
        setOpenEditBlockedPeriod(true);
        break;
    }
  };

  return (
    <>
      <div
        className={`${themeStyles.main.tailwindMainBg}`}
        style={{
          height: `calc(100vh - ${timeLineHeight - 40}px)`
        }}
      >
        <div className="calendar"
          style={{
            fontSize: "14px",
            lineHeight: 1.2,
            display: "flex",
            flexDirection: "column",
            WebkitUserSelect: "none" /* Safari */,
            msUserSelect: "none" /* IE 10 and IE 11 */,
            userSelect: "none" /* Standard syntax */,
            touchAction: "none",
            boxSizing: "border-box"
          }}
        >
          <CalendarHeader
            setTimeLineHeight={setTimeLineHeight}
            time={currentTimeLineView}
            setTime={(time) => {
              setIsRefresh(true);
              setCurrentTimeLineView(time);
            }}
            setResourcesDataIsLoaded={setResourcesDataIsLoaded}
            onPrint={onPrint}
            setStartDate={(value) => {
              setIsRefresh(true);
              setCustomStartDate(value);
            }}
            setEndDate={(value) => {
              setIsRefresh(true);
              setCustomEndDate(value);
            }}
          />

          <Timeliner
            customStartDate={customStartDate}
            customEndDate={customEndDate}
            timeLineHeight={timeLineHeight}
            groups={vehilceClassData}
            groupsIsLoaded={vehicleClassDataIsDataLoaded}
            resources={vehilceData}
            resourcesIsLoaded={vehicleDataIsDataLoaded}
            events={reservationItem}
            eventsIsLoaded={reservationItemsIsLoaded}
            resourcesDataIsLoaded={resourcesDataIsLoaded}
            setResourcesDataIsLoaded={setResourcesDataIsLoaded}
            views={currentTimeLineView}
            onItemClick={handleEventClick}
            print={setOnPrint}
          />
        </div>
      </div>

      {
        openEditBlockedPeriod && (
          <EditBlockedPeriod
            vehicleId={vehicleId}
            openEditBlockedPeriod={openEditBlockedPeriod}
            setOpenEditBlockedPeriod={setOpenEditBlockedPeriod}
            setRefreshBlockedPeriodList={setIsRefresh}
            blockedPeriodId={blockedPeriodId}
          />
        )
      }
    </>
  );
};

export default Calendar; 